import ecran from '../../../../../core/injectors/ecran.injector';
import Cp0061Controller from './cp0061.controller';

export default ecran({
    source: 'cp0061',
    ecrans: ['00-2'],
    template: require('./cp0061.html'),
    controller: Cp0061Controller
});
